import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "8",
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.68757 0.520551C1.49234 0.278899 1.13818 0.241264 0.896528 0.436492C0.654876 0.63172 0.617241 0.985881 0.812469 1.22753C1.1636 1.66217 1.59984 2.13205 2.12679 2.58267L0.754898 4.95886C0.599568 5.2279 0.691748 5.57191 0.960787 5.72724C1.22983 5.88258 1.57385 5.7904 1.72918 5.52136L3.03059 3.26724C3.73437 3.73614 4.55746 4.14411 5.50797 4.41277L5.09873 6.73371C5.04478 7.03965 5.24906 7.33139 5.55501 7.38534C5.86095 7.43928 6.15269 7.235 6.20664 6.92906L6.60872 4.64874C7.04915 4.7143 7.51273 4.75001 8.00006 4.75001C8.48496 4.75001 8.94635 4.71466 9.38481 4.64972L9.7869 6.93006C9.84085 7.236 10.1326 7.44028 10.4385 7.38633C10.7445 7.33239 10.9488 7.04064 10.8948 6.7347L10.4857 4.41458C11.4373 4.14641 12.2613 3.73861 12.9659 3.26968L14.2598 5.5109C14.4152 5.77994 14.7592 5.87212 15.0282 5.71679C15.2973 5.56146 15.3895 5.21744 15.2341 4.9484L13.8699 2.58557C14.3984 2.13407 14.8357 1.66311 15.1876 1.22755C15.3829 0.985899 15.3452 0.631737 15.1036 0.436509C14.8619 0.241281 14.5078 0.278915 14.3125 0.520566C13.9229 1.0029 13.4241 1.52535 12.8057 2.00163C12.8017 2.00465 12.7977 2.00773 12.7937 2.01084C11.6358 2.89946 10.0605 3.62501 8.00006 3.62501C5.94276 3.62501 4.36909 2.90164 3.21161 2.01486C3.20221 2.00713 3.19252 1.99966 3.18253 1.99248C2.56967 1.51866 2.07475 0.999803 1.68757 0.520551Z",
  fill: "#839AAF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }